// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-theme_common {
  --ck-veil-background: var(--g-color-sfx-fade);
  --ck-controls-backgound: transparent;
}

.chartkit-base {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  width: 100%;
}
.chartkit-base__header {
  z-index: 2;
  position: absolute;
  top: -4px;
  right: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.chartkit-base__body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
}
.chartkit-base__body_hidden {
  opacity: 0;
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/ChartKitBase.scss","webpack://./src/ui/libs/DatalensChartkit/styles/theme.scss"],"names":[],"mappings":"AAEA;ECAI,6CAAA;EAGA,oCAAA;ADFJ;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAAJ;AAEI;EACI,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAAR;AAGI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AADR;AAGQ;EACI,UAAA;EACA,WAAA;AADZ","sourcesContent":[".chartkit-theme_common {\n  --ck-veil-background: var(--g-color-sfx-fade);\n  --ck-controls-backgound: transparent;\n}\n\n.chartkit-base {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n  width: 100%;\n}\n.chartkit-base__header {\n  z-index: 2;\n  position: absolute;\n  top: -4px;\n  right: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.chartkit-base__body {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n}\n.chartkit-base__body_hidden {\n  opacity: 0;\n  z-index: -1;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
